module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/addeditcustomer/addeditcustomer.component.css
// module id = ./src/app/addeditcustomer/addeditcustomer.component.css
// module chunks = main